// TODO replace with npm packages where possible

import strnatcmp = require('./strnatcmp')
import superagent = require('./superagent')

export {
  strnatcmp,
  superagent,
}
